module.exports = __webpack_public_path__ + "static/media/family_13.00dae790.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_13.jpg
// module id = 5845
// module chunks = 0